import TopBar from "components/Header/TopBar";
import { useAuth } from "hooks/useAuth";
import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { useLocation } from "react-router-dom";

const RootLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const authContext = useAuth();
  const { pathname } = useLocation();

  //This is used as react router is keeping scroll position persisted while we navigate between the rputes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="bg-offWhite  h-full overflow-hidden">
      <div className="flex flex-col w-full">
        <Toaster />
        {!!authContext?.user && (
          <div className="h-[60px]">
            <TopBar authContext={authContext} />
          </div>
        )}
        <div className="flex-1 ">{children}</div>
        <div id="portal" />
        <div id="banner" />
      </div>
    </div>
  );
};

export default RootLayout;
